export default {
  show: true,
  clippedOver: false,
  dense: false,
  shrinkOnScroll: false,
  hideOnScroll: false,
  prominent: false,
  floating: true,
};
